export const BASE_URL: string = 'https://api.ng.termii.com/api'
